<template>
  <div class="radios">
    <slot>
      <Radio
        v-for="(item, index) in radios"
        :key="index"
        :radio="item"
        class="radio-item"
        @switchStatus="switchStatus"
      >
      </Radio>
    </slot>
  </div>
</template>

<script lang="ts">
import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import Radio from './Radio.vue';

@Component({
  components: {
    Radio,
  },
  model: {
    prop: 'currentActive',
    event: 'updateCurrentActive',
  },
})
export default class Radios extends Vue {
  @Prop({ type: Array }) radios!: [];
  @Prop({ type: String }) currentActive!: '';
  @Watch('currentActive')
  changeCurrentActive(newValue: any) {
    const radio = { key: newValue };
    this.$emit('update:radios', this.changeRadios(radio));
  }

  changeRadios(radio: any) {
    let radios = JSON.parse(JSON.stringify(this.radios));
    radios = radios.map((item: any, index: any) => {
      radio && radio.key === item.key
        ? (item.value = true)
        : (item.value = false);
      return item;
    });
    return radios;
  }
  switchStatus(radio: any) {
    const radios = this.changeRadios(radio);
    this.$emit('update:radios', radios);

    this.$emit('updateCurrentActive', radio.key);
    this.$emit('change', radio, radios);
  }
}
</script>

<style lang="scss" scoped>
.radios {
  display: flex;
  align-items: center;
  height: 100%;
  .radio-item {
    & + .radio-item {
      margin-left: 87px;
    }
  }
}
</style>
